import React, { useEffect } from "react";
import MaterialTable from 'material-table';

// reactstrap components
import { Button, Card, CardBody, Row, Col, Container } from "reactstrap";

// style
import { table_translate } from "../../../constants/MaterialTable.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_POST } from "../../../services/api_service.js";

//Context
import { useAuth } from "../../../context/auth";

export default function ListaEquipamentosExclusao({ item, protocolo, handleProximoStep }) {
    const { setLoading } = useAuth();


    const [registro, set_registro] = React.useState(null);

    const [equipamentos, set_equipamentos] = React.useState([]);
    const [equipamentosExcluir, setEquipamentosExcluir] = React.useState([]);

    const loadItemRequerimento = () => {
        set_registro(item);
        if (protocolo != null && protocolo.protocoloTransportador[0].protocoloTransportadorEquipamento != null) {
            set_equipamentos(protocolo.protocoloTransportador[0].protocoloTransportadorEquipamento);
        }
        if (item != null && item.requerimentoTransportadorEquipamento != null && protocolo != null && protocolo.protocoloTransportador[0].protocoloTransportadorEquipamento != null) {
            let excluded = protocolo.protocoloTransportador[0].protocoloTransportadorEquipamento.filter(pe =>
                !item.requerimentoTransportadorEquipamento.some(re => re.numeroEquipamento == pe.numeroEquipamento)
            );
            setEquipamentosExcluir(excluded);
        }
    }

    useEffect(() => {
        loadItemRequerimento();
    }, [protocolo]);

    const handleAvancar = () => {
        if (equipamentosExcluir.length == 0) {
            showMessage("Aviso", "Selecione os equipamentos que deseja excluir!", 'error', null);
            return;
        }

        let json_submit = [];
        equipamentosExcluir.map(m => {
            json_submit.push(m.protocoloTransportadorEquipamento_Id);
        })

        setLoading(true);
        api_POST(`requerimentoTransportador/PostRequerimentoTransportadorExclusaoEquipamento/${registro.requerimento_Id}`, json_submit)
            .then(result => {
                let updatedRegistro = result.data && result.data.requerimento_Id ? result.data : { ...registro, requerimentoTransportadorEquipamento: equipamentosExcluir };
                handleProximoStep(updatedRegistro);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div>

                <Card className="card-stats">
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Equipamentos</h2>
                            <div className="formPrincipal">
                                <Row>
                                    <Col md="12">
                                        <MaterialTable style={{ minHeight: "auto" }}
                                            title=""
                                            columns={[
                                                { title: 'Número do Equipamento', field: 'numeroEquipamento' },
                                                { title: 'Tipo', field: 'tipo' },
                                                { title: 'Dimensão', field: 'dimensao' },
                                                { title: 'Capacidade', field: 'capacidadeVolume' },
                                                { title: 'Status', field: 'status' }
                                            ]}
                                            data={equipamentos}
                                            isLoading={false}
                                            options={{
                                                selection: true
                                            }}
                                            onSelectionChange={(rows) => setEquipamentosExcluir(rows)}
                                            localization={table_translate}
                                        />
                                    </Col>
                                    <Col lg="6" className="text-left">
                                    </Col>
                                    <Col lg="6" className="text-right">
                                        {handleProximoStep != null &&
                                            <Button color="success" onClick={handleAvancar} className="btn-mobile" type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}           